var AppointmentsChangePatientDataTestId = /* @__PURE__ */ ((AppointmentsChangePatientDataTestId2) => {
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_LIST_TITLE"] = "appointments--change-patient-list-title";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_LIST_SUBTITLE"] = "appointments--change-patient-list-subtitle";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_LIST_EMPTY_STATE"] = "appointments--change-patient-list-empty-state";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_CREATE_ANOTHER_BUTTON"] = "appointments--change-patient-create-another-button";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_CONFIRM_SCHEDULED_FOR"] = "appointments--change-patient-confirm-scheduled-for";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_CONFIRM_BACK_BUTTON"] = "appointments--change-patient-confirm-back-button";
  AppointmentsChangePatientDataTestId2["CHANGE_PATIENT_CONFIRM_BUTTON"] = "appointments--change-patient-confirm-button";
  return AppointmentsChangePatientDataTestId2;
})(AppointmentsChangePatientDataTestId || {});
export {
  AppointmentsChangePatientDataTestId
};
